module.exports = __webpack_public_path__ + "static/media/problem-types.f2d8b4be.svg";